/* eslint-disable prefer-destructuring */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const contentful = require('contentful')

const client = contentful.createClient({
  space: process.env.CTF_SPACE_ID,
  accessToken: process.env.CTF_CDA_ACCESS_TOKEN,
  include: 3,
})

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return '' // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase()
  })
}

const state = {
  pages: {
    loaded: false,
  },
  news: {
    loaded: false,
  },
  menus: {
    loaded: false,
  },
  portfolio: {
    loaded: false,
  },
}
const getters = {
  pages: state => state.pages,
  news: state => state.news,
  menus: state => state.menus,
  portfolio: state => state.portfolio,
  categories: state => state.portfolio.categories.items.map(element => element),
  pagesLoaded: state => state.pages.loaded,
  newsLoaded: state => state.news.loaded,
  menusLoaded: state => state.menus.loaded,
  portfolioLoaded: state => state.portfolio.loaded,
}
const mutations = {
  setLoaded(state, data) {
    // console.log('setLoaded', data)
    state[data.name].loaded = data.value
  },
  setPages(state, data) {
    data.items.forEach(element => {
      state.pages[camelize(element.fields.title)] =
        element.fields.contentModules
    })
  },
  setMenu(state, data) {
    state.menus[camelize(data.fields.menuPosition)] = data
  },
  setNews(state, data) {
    // console.log('setNews', data)
    state.news.posts = data
  },
  setPortfolio(state, data) {
    // console.log('setPortfolio', data)
    state.portfolio.posts = data
  },
  setCategories(state, data) {
    // console.log('setCategories', data)
    state.portfolio.categories = data
  },
}
const actions = {
  async refreshContent({ dispatch }, payload) {
    // await payload.pages.forEach(element => dispatch('getPage', element))
    await dispatch('getPages')
    await payload.menus.forEach(element => dispatch('getMenu', element))
  },
  async getPage({ commit }, id) {
    client
      .getEntry(id)
      .then(entry => {
        commit('setPage', entry)
      })
      .then(() => commit('setLoaded', { name: 'pages', value: true }))
      .catch(err => {
        console.log(err)
        commit('setLoaded', { name: 'pages', value: false })
      })
  },
  async getPages({ commit }) {
    client
      .getEntries({
        include: 4,
        content_type: process.env.CTF_PAGE_POST_TYPE_ID,
      })
      .then(pages => {
        commit('setPages', pages)
      })
      .then(() => commit('setLoaded', { name: 'pages', value: true }))
      .catch(err => {
        console.log(err)
        commit('setLoaded', { name: 'pages', value: false })
      })
  },
  async getNews({ commit }) {
    client
      .getEntries({
        limit: 10,
        order: '-fields.date',
        content_type: process.env.CTF_NEWS_POST_TYPE_ID,
      })
      .then(news => {
        commit('setNews', news)
        commit('setLoaded', { name: 'news', value: true })
      })
      .catch(err => {
        console.log(err)
        commit('setLoaded', { name: 'news', value: false })
      })
  },
  getPortfolio({ commit, dispatch }) {
    client
      .getEntries({
        limit: 999,
        order: 'sys.createdAt',
        content_type: process.env.CTF_PORTFOLIO_POST_TYPE_ID,
        include: 3,
      })
      .then(data => {
        commit('setPortfolio', data)
      })
      .then(dispatch('getCategories'))
      .catch(err => {
        console.log(err)
        commit('setLoaded', { name: 'portfolio', value: false })
      })
  },
  getCategories({ commit }) {
    client
      .getEntries({
        limit: 999,
        content_type: 'categories',
        include: 2,
      })
      .then(data => {
        commit('setCategories', data)
      })
      .then(() => commit('setLoaded', { name: 'portfolio', value: true }))
      .catch(err => {
        console.log(err)
      })
  },
  async getMenu({ commit }) {
    client
      .getEntries({
        include: 3,
        content_type: 'menus',
      })
      .then(entries => {
        entries.items.forEach(element => {
          commit('setMenu', element)
        })
      })
      .then(() => commit('setLoaded', { name: 'menus', value: true }))
      .catch(err => {
        console.log('error', err)
        commit('setLoaded', { name: 'menus', value: false })
      })
  },
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js